module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_gc_zhyq.79474731.png";